import { Button, SxProps, Theme } from '@mui/material';
import React from 'react';
import { Flow } from '../types/flow';
import { useFlow } from '../hooks/useFlow';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ColorPalettes } from '../../../../../patient/src/features/reservation/constants/ColorPalettes';

interface Props {
  flow: Flow;
  title: string;
  sx?: SxProps<Theme>;
}

const defaultSx: SxProps<Theme> = { bgcolor: ColorPalettes.MAIN, color: ColorPalettes.WHITE };

function TransitionButton({ flow, title, sx = defaultSx }: Props) {
  const { setFlow } = useFlow();
  const handleClick = () => {
    setFlow(flow);
  };
  return (
    <Button
      className="flex items-center gap-x-2 mx-auto w-4/5 py-4 rounded-lg font-bold text-2xl sm:text-3xl hover:bg-primary/80"
      sx={sx}
      onClick={handleClick}
    >
      {title}
      <ArrowForwardIosIcon />
    </Button>
  );
}

export default TransitionButton;
